import { render, staticRenderFns } from "./home.vue?vue&type=template&id=349421f5&scoped=true&"
var script = {}
import style0 from "./home.scss?vue&type=style&index=0&id=349421f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349421f5",
  null
  
)

export default component.exports